import { useEffect, useRef } from 'react'

// Module-level set shared across all instances — survives remounts.
const globalOpenedIds = new Set<string>()

/**
 * Auto-opens a canvas card the first time it appears.
 *
 * Call inside any canvas card component passing the unique `cardId`
 * (typically the CopilotKit toolCallId) and a callback that opens the
 * canvas. Fires the callback exactly once per `cardId` for the lifetime
 * of the page.  If the user closes the canvas, it won't re-open for
 * that same id.
 */
export function useAutoOpenCanvas(cardId: string | undefined, open: () => void) {
  const openRef = useRef(open)
  openRef.current = open

  useEffect(() => {
    if (!cardId) return
    if (globalOpenedIds.has(cardId)) return
    if (window.innerWidth <= 624) return
    globalOpenedIds.add(cardId)
    openRef.current()
  }, [cardId])
}
